var ModalMessage = function () {

};

ModalMessage.show = function (message) {
    App.blockUI({ textOnly: false, boxed: true, message: message, zIndex: 11000 });
};

ModalMessage.hide = function (elmentId) {
    App.unblockUI();
};

ModalMessage.alert = function (title, message, callback) {
    var options = {
        title: title,
        message: message
    };

    if (callback != null) {
        options.buttons = {
            main: {
                label: "Ok",
                className: "btn-primary",
                callback: function () {
                    callback();
                }
            }
        };
    }

    bootbox.dialog(options);
};

ModalMessage.confirm = function (title, message, callback, cancelCallback) {
    const dialog = bootbox.dialog({
        title: title,
        message: message,
        onEscape: function () {
            bootbox.hideAll();
            if (typeof cancelCallback != 'undefined')
                cancelCallback();
        },
        buttons: {
            success: {
                label: 'Sim',
                className: 'blue btn-primary',
                callback: function () {
                    callback();
                }
            },
            main: {
                label: 'Não',
                className: 'default',
                callback: function () {
                    if (typeof cancelCallback != 'undefined')
                        cancelCallback();
                }
            }
        }
    });

    setTimeout(() => {
        const modalContent = dialog.find('.modal-content');
        const modalTitle = dialog.find('.modal-title');
        const modalBody = dialog.find('.bootbox-body');

        modalContent.attr('role', 'dialog');
        modalContent.attr('aria-modal', 'true');
        modalContent.attr('tabindex', '-1');
        modalContent.attr('aria-labelledby', modalTitle.attr('id') || 'modalTitle');
        modalContent.attr('aria-describedby', modalBody.attr('id') || 'modalBody');

        if (!modalTitle.attr('id')) modalTitle.attr('id', 'modalTitle');
        if (!modalBody.attr('id')) modalBody.attr('id', 'modalBody');

        modalContent.focus();
    }, 50);

    return dialog;
};

export default ModalMessage;